<template>
  <!-- 底部 -->
  <footer class="footer">
    <div class="footer_content">
      <el-row align="bottom">
        <el-col :span="8">
          <div class="footer_item">
            <div class="footer_left">
              <img
                width="27.5"
                height="30.8"
                src="../../assets/images/flogo.png"
              />
              <p>普洱市科技成果转化服务平台</p>
              <div>
                <a tag="a" target="_blank" :href="siteRecordNum.icpLinkUrl">
                  <span class="beian">{{ siteRecordNum.icpNum }}</span>
                </a>
                <span>|</span>
                <img width="24" height="24" :src="siteRecordNum.imageUrl" />
                <a
                  tag="a"
                  target="_blank"
                  :href="siteRecordNum.publicSecurityLinkUrl"
                >
                  <span class="beian">{{
                    siteRecordNum.publicSecurityNum
                  }}</span>
                </a>
                <!-- <img
                  width="24"
                  height="24"
                  src="../../assets/images/ficon.jpg"
                /> -->
                <!--  -->
                <!-- <span>正公网安备5310302000902号</span> -->
              </div>
              <p>普洱辰宇科技技术支持</p>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="footer_item item2">
            <div class="footer_item_main">
              <p>联系电话 service tel</p>
              <p>{{ siteContactInfo.consumerHotline }}</p>
              <p>(周一至周五9:00-18:00)</p>
              <p style="padding-top: 30px">
                传真：{{ siteContactInfo.faxAddress }}
              </p>
              <p>{{ siteContactInfo.email }}</p>
            </div>
          </div>
        </el-col>
        <el-col :span="3">
          <div class="footer_item item3">
            <div class="footer_item_main">
              <p>友情链接</p>
              <a
                v-for="(item, index) in siteLinks"
                :key="index"
                :href="item.linkUrl"
                target="_blank"
              >
                <p>
                  {{ item.linkName }}
                </p>
              </a>
            </div>
          </div>
        </el-col>
        <el-col :span="7" class="item4">
          <div class="code">
            <div class="code_img">
              <el-image
                :src="siteQrCode.qrCodeUrl"
                style="height: 100%"
                fit="contain"
              >
              </el-image>
            </div>
            <span>扫一扫二维码关注</span>
          </div>
        </el-col>
      </el-row>
    </div>
  </footer>
</template>
<script>
import { BASEURL } from '../../assets/js/ajax'
export default {
  data () {
    return {
      //icp备案号
      siteRecordNum: {
        icpNum: '滇ICP备2020009097号',
        icpLinkUrl: '',
        imageUrl: require('../../assets/images/code.jpg')
      },
      //联系信息
      siteContactInfo: {
        consumerHotline: '0879-2142419',
        faxAddress: '0879-2200677',
        email: 'peskjcgzhzx003@163.com'
      },
      siteLinks: [],//友情链接
      siteQrCode: {
        qrCodeUrl: require('../../assets/images/code.jpg')
      }
    }
  },
  created () {
    this.getSiteInfo()
  },
  methods: {
    async getSiteInfo (data, index) {
      let res = await this.$ajax('/pc/siteInfo/getSiteInfo', data, 'POST')
      if (res.code === 20000) {
        this.siteRecordNum = res.data.icp[0];
        this.siteRecordNum.imageUrl = BASEURL + res.data.icp[0].imageUrl
        this.siteContactInfo = res.data.contact[0];
        this.siteLinks = res.data.links;
        this.siteQrCode.qrCodeUrl = BASEURL + res.data.qrCode[0].qrCodeUrl
      }
      console.log("response", JSON.stringify(this.siteQrCode.qrCodeUrl));
    }

  }
}
</script>
<style>
.footer {
  position: absolute;
  bottom: 0px;
  width: 100%;
  height: 334px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  color: #8b939a;
  background-color: #2d3237;
}
.footer_content {
  position: relative;
  width: 75%;
  margin-right: 12%;
  margin-top: 61px;
  left: 50%;
  transform: translateX(-50%);
}
.footer_left {
  position: absolute;
  top: 50% !important;
  transform: translateY(-50%);
  left: 0px;
}
.footer_left > div {
  height: 38px;
  display: flex;
  align-items: center;
}
.footer_left > img {
  padding-bottom: 8px;
}
.footer_left > div span:nth-child(2) {
  padding: 0 8px;
}
.footer_left > div span:last-child {
  padding: 0 8px;
}
.footer_left,
.footer_item,
.code,
.item4,
.item2,
.item3 {
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}
.footer_item {
  position: relative;
  height: 202px;
  border-left: 1px solid #8b939a;
  font-size: 15px;
  text-align: left;
}
.footer_content .footer_item:first-child {
  border: none;
}
.footer_content .footer_item:last-child {
  border-right: 1px solid #8b939a;
}
.footer_item p {
  padding: 2px 0;
}
.item3 p {
  font-size: 15px;
  font-family: Source Han Sans CN;
  color: #8b939a;
  padding: 6px 0;
}
a {
  text-decoration: none;
}

.router-link-active {
  text-decoration: none;
}
.item2 p:nth-child(2) {
  font-size: 30px;
}
.item3 p:first-child {
  font-weight: bold;
}
.item2,
.item3 {
  /* display: flex;
    align-items: center;
    justify-content: space-around; */
}
.item4 {
  height: 202px;
  justify-content: space-around;
}
.code {
  float: right;
  text-align: center;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
}
.code_img {
  width: 156px;
  height: 156px;
  margin-bottom: 2pt;
  background-color: tomato;
}
.footer_item_main {
  position: absolute;
  width: 80%;
  left: 60%;
  transform: translateX(-50%);
  margin: 0 auto;
}
.beian {
  color: #8b939a;
}
</style>


// WEBPACK FOOTER //
// src/components/Footer/Footer.vue